var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('detail',{attrs:{"on-manager":_vm.onManager,"data":_vm.data,"base-info":_vm.baseInfo,"resource":"dns_recordsets","hiddenKeys":['tenant', 'project_domain', 'status'],"nameProps":{edit: false}}})}
var staticRenderFns = []

export { render, staticRenderFns }